module.exports = __webpack_public_path__ + "media/static/icons/icon-river-5090d49bdb7e9e82c9da2df347c4d4f8.svg";